import { render, staticRenderFns } from "./AmDataMainPage.vue?vue&type=template&id=44bb7160&scoped=true&"
import script from "./AmDataMainPage.vue?vue&type=script&lang=js&"
export * from "./AmDataMainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bb7160",
  null
  
)

export default component.exports